import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el producto después de la compra?',
  a: 'Inmediatamente después de confirmar tu pago recibirás un correo electrónico con el acceso instantáneo a La Biblia de 500 Prompts y a los 3 bonos incluidos. La entrega es 100% digital y automática.'
}, {
  q: '¿Necesito pagar ChatGPT Plus para usar los prompts?',
  a: 'No es obligatorio. Los prompts funcionan perfectamente con la versión gratuita de ChatGPT, aunque la versión Plus te dará respuestas más rápidas y mejores resultados para prompts complejos.'
}, {
  q: '¿Los prompts funcionan en otras IA como Claude o Gemini?',
  a: 'Sí. Aunque están optimizados para ChatGPT, los prompts también funcionan excelente en Claude, Gemini, Perplexity y otras IAs basadas en lenguaje natural.'
}, {
  q: '¿En qué idioma están los prompts?',
  a: 'Todos los prompts están en español natural y optimizado. También puedes pedirle a la IA que te devuelva respuestas en inglés o cualquier otro idioma si lo necesitas.'
}, {
  q: '¿Puedo usar los prompts para mi negocio o clientes?',
  a: 'Por supuesto. Puedes usar los resultados generados con los prompts para tu propio negocio, agencia, clientes o proyectos personales. Lo único prohibido es revender o redistribuir el ebook mismo.'
}, {
  q: '¿Cuánto tiempo tengo acceso al material?',
  a: 'Acceso de por vida. Pagas una sola vez y descargas todo el material a tu dispositivo. No hay suscripciones, no hay renovaciones, no hay letra pequeña.'
}, {
  q: '¿Necesito conocimientos técnicos para usarlos?',
  a: 'Cero. Solo necesitas saber copiar y pegar. Cada prompt viene con instrucciones simples y variables claras para que personalices según tu necesidad.'
}, {
  q: '¿Qué pasa si no me gusta el producto?',
  a: 'Ofrecemos una garantía de satisfacción de 7 días. Si por alguna razón el producto no cumple con tus expectativas, escríbenos y procesamos tu reembolso sin complicaciones.'
}];
function FAQItem({
  q,
  a,
  index,
  isOpen,
  onToggle
}: {
  q: string;
  a: string;
  index: number;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.05
  }} className={`border-b border-gold/10 ${isOpen ? 'bg-gold/[0.02]' : ''} transition-colors duration-300`} data-id="element-64">
      <button onClick={onToggle} className="w-full py-7 flex items-center justify-between gap-6 text-left group" data-id="element-65">
        <span className={`font-display text-lg md:text-xl text-cream group-hover:text-gold transition-colors leading-snug ${isOpen ? 'text-gold' : ''}`} data-id="element-66">
          {q}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 45 : 0
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className={`shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-colors ${isOpen ? 'border-gold/60 bg-gold/10 text-gold' : 'border-gold/20 text-cream/60 group-hover:border-gold/40 group-hover:text-gold'}`} data-id="element-67">
          <Plus size={16} data-id="element-68" />
        </motion.div>
      </button>

      <AnimatePresence initial={false} data-id="element-69">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="overflow-hidden" data-id="element-70">
            <p className="text-cream/65 font-light leading-[1.85] pb-7 pr-16 max-w-3xl text-[15px] md:text-base" data-id="element-71">
              {a}
            </p>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 md:py-32 relative" data-id="element-72">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[700px] h-[500px] bg-[radial-gradient(circle_at_center,rgba(212,175,122,0.05)_0%,transparent_70%)] blur-3xl pointer-events-none" data-id="element-73"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-75">
          <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-6" data-id="element-76">
            Preguntas Frecuentes
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-cream mb-6 leading-[1.05]" data-id="element-77">
            Todo lo que necesitas{' '}
            <span className="text-gold italic" data-id="element-78">saber</span>
          </h2>
          <p className="text-cream/60 text-lg font-light max-w-xl mx-auto" data-id="element-79">
            Las respuestas a las preguntas más comunes antes de adquirir
            Elemental.
          </p>
        </motion.div>

        <div className="border-t border-gold/10" data-id="element-80">
          {faqs.map((faq, idx) => <FAQItem key={idx} q={faq.q} a={faq.a} index={idx} isOpen={openIndex === idx} onToggle={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-81" />)}
        </div>
      </div>
    </section>;
}